
import anime from 'animejs';
import {defineComponent, onMounted, ref} from '@nuxtjs/composition-api'
import core, {} from '~/core';

export default defineComponent({
    props: {
        text: {default: ''}
    },
    setup(props, ctx){
        const str = ref(props.text || '');

        const close = () => {
            anime({
                targets: '#alert',
                translateY: [0, 300],
                scale: [1, 0.7],
                duration: 300,
                easing: 'easeInQuad',
                
                complete: () => {
                    ctx.emit('destroyMe');
                }
            });
        }
        const open = () => {
            anime({
                targets: '#alert',
                translateY: [300, 0],
                scale: [0.7, 1],
                duration: 300,
                delay: 400,
                easing: 'easeOutQuad',
                begin: () => {
                    try{
                        navigator.vibrate(300);
                    }
                    catch(err){
                        
                    }
                    anime({
                        targets: '#alert i.fa-bell',
                        direction: 'alternate',
                        duration: 400,
                        loop: true,
                        easing: 'easeInQuad',
                        rotate: function(el, i, l){
                            let ang = <number>anime.get(el, 'rotate');
                            // console.log(`rotate ${ang}`);
                            
                            if(ang === 0)
                                return 45;
                            if(ang > 0)
                                return -ang;
                            if(ang < 0)
                                return Math.abs(ang)/4;
                        }
                    });
                },
                complete: () => {
                    setTimeout(() => {
                        close()
                    }, 7000);
                    
                }
            })
        }

        onMounted(() => {
            core.alerts.events.notification.on((payload) => {
                str.value = payload.message;
                open();
            })
        })
        return {
            str,
            open, close
        }
    },
    
})
